<template>
<div class="fc-page mg-page mg-role_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>角色管理</h1><p>管理机构角色，按职责配置页面与操作权限</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">添加角色</v-btn></div></header><section class="fc-records" aria-label="角色列表"><div class="fc-list-heading"><h3>角色列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">

				{{ roleStatusName(item.status) }}
			</template>
			<template v-slot:item.isSuper="{item}">

				{{ isSuperName(item.isSuper) }}
			</template>
			<template v-slot:item.allowDelete="{item}">
				<v-chip small :color="allowDeleteColor(item.allowDelete)">{{ allowDeleteName(item.allowDelete) }}
				</v-chip>
			</template>

			<template v-slot:item.action="{item}">
				<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改</v-btn>
				</v-btn>
				<v-btn @click="showAclDialog(item)" color="#d9363e" small class="ml-3" depressed>分配权限</v-btn>
			</template>

		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="添加角色" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>添加角色信息</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭添加角色" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-text-field label="角色名称" v-model="add.role.roleName" dense outlined color="#d9363e" aria-label="角色名称"></v-text-field>
					</v-col>

				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitAddRole" color="#d9363e" :disabled="add.doing" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="修改角色" v-model="update.dialog" max-width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>修改角色信息</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改角色" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-text-field label="角色名称" v-model="update.role.roleName" dense outlined color="#d9363e" aria-label="角色名称"></v-text-field>
					</v-col>
					<v-col cols="3">
						<v-switch v-model="update.role.status" class="mt-0" color="info"
							label="状态"></v-switch>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitUpdateRole" color="#d9363e" depressed class="fc-confirm" >确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="为商户角色分配权限" v-model="acl.dialog" max-width="1000" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog mg-acl-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>为</span>
				<span class="text-h6 orange--text">{{acl.role.roleName}}</span>
				<span>分配权限</span></h2><p>按模块查看页面与功能权限，勾选后保存</p></div><v-spacer/><v-btn icon aria-label="关闭为商户角色分配权限" @click="acl.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row class="mg-acl-heading">
					<v-col cols="2"><span style="color:white">模块</span></v-col>
					<v-col cols="3"><span style="color:white">页面</span></v-col>
					<v-col cols="7"><span style="color:white">功能权限</span></v-col>
				</v-row>
				<v-row v-for="(item,index) in functionList" align="center" :key="item.functionId" class="mg-acl-module" >
					<v-col cols="2">
						<span class="text-subtitle-1">{{item.functionName}}</span>
					</v-col>
					<v-col cols="10" v-if="item.children">
						<v-row v-for="(page,m) in item.children" :key="page.functionId" align="center">
							<v-col cols="3" >
								<div @click="showWarn" style="cursor: pointer;">
									<v-checkbox v-model="page.hasAcl" disabled :label="page.functionName"
									color="warning" false-value="0" true-value="1" ></v-checkbox>
								</div>
							</v-col>
							<v-col cols="9">
								<v-card v-if="page.children" class="mg-acl-actions">
									<v-checkbox v-for="(btn,n) in page.children" class="ml-4" :key="btn.functionId"
									v-model="btn.hasAcl" :label="btn.functionName" false-value="0" true-value="1"
									color="success" hide-details @change="btnCheckboxChanged(btn)"></v-checkbox>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="acl.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitRoleAcl" color="#d9363e" :loading="acl.submiting" :disabled="acl.submiting" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "role-list",
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '角色管理',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [{
							text: '角色名称',
							value: 'roleName',
							sortable: false
						},
						{
							text: '是否超级管理员',
							value: 'isSuper',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				search: "",
				query: {
					loading: false,
					page: 1,
					size: 20,
				},
				add: {
					dialog: false,
					adding:false,
					role: {
						roleName: "",
					},
				},
				update: {
					dialog: false,
					role: {
						roleId: "",
						roleName: "",
						status:"",
					}
				},
				acl: {
					dialog: false,
					submiting:false,
					role: {
						roleId: ""
					}
				},
				checkedFunctionIds:[],// 选中的值
				functionList: [] // 角色的权限列表
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			console.log("role list created");
			this.getRoleList();

		},
		methods: {
			showWarn(){
				this.$noty.error("请直接选择后面的权限");
				return
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getRoleList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getRoleList();
			},
			showAddDialog() {
				this.add.dialog = true;
			},
			getRoleList() {
				const that = this;
				this.query.loading = true;

				let url = `/sys/role/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;

				this.axios.get(url).then(response => {


					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			isSuperColor(state) {

				let stName = "";
				if (state === "1") {
					stName = "success";
				} else if (state === "0") {
					stName = "error";
				}
				return stName;
			},
			isSuperName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "是";
				} else if (state === "0") {
					stName = "否";
				}
				return stName;
			},
			roleStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "已作废";
				}
				return stName;
			},
			roleStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddRole() {
				
				
				// 添加角色
				if (!this.add.role.roleName) {
					this.$noty.error('角色名称不能为空');
					return
				}
				this.add.adding = true;
				
				// api
				const that = this;
				let url = `/sys/role/create`;
				let postData = {
					...this.add.role
				};
				postData.shopId = this.shopId;
				
				this.axios.post(url, postData).catch(() => {
					that.add.adding = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getRoleList();
							that.add.dialog = false;
							that.add.adding = false;
							return;
						} else {
							that.add.adding = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.adding = false;
						that.$noty.error('网络请求失败');
					}

				});

			},
			showUpdate(item) {
				if (item.isSuper == "1") {
					this.$noty.error("超级管理员角色不允许修改");
					return;
				}
				
				this.update.dialog = true;
				this.update.role.roleId = item.id;	
				this.update.role.roleName = item.roleName;
		
				this.update.role.status = item.status == "1" ? true : false;
				
			},
			submitUpdateRole() {
				//修改角色
				
				if (!this.update.role.roleName) {
					this.$noty.error('角色名称不能为空');
					return
				}

				// api
				const that = this;
				let url = `/sys/role/update`;

				// parameters
				let st = this.update.role.status?"1":"0";
				
				const updateData = {
					...this.update.role
				}
				
				updateData.status =  st;

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getRoleList();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showAclDialog(item) {

				if (item.isSuper == "1") {
					this.$noty.error("超级管理员角色不需要分配权限");
					return;
				}

				this.acl.dialog = true;
				this.acl.role.roleId = item.id;
				this.acl.role.roleName = item.roleName;
				
				// 清空上次选中的项
				this.checkedFunctionIds = [];
				//获取角色权限列表
				this.getRoleAclList();
				
				
			},
			submitRoleAcl() {
				this.acl.submiting = true;
				//保存权限
				// 处理选中的ID
				this.checkedFunctionIds = [];
				if (this.functionList){
					this.functionList.forEach((item,index)=>{
						if (item.children){
							item.children.forEach((page,m)=>{
								if (page.hasAcl == '1'){
									this.checkedFunctionIds.push(page.functionId);
								}
								if (page.children) {
									page.children.forEach((btn,n)=>{
										if (btn.hasAcl == '1'){
											this.checkedFunctionIds.push(btn.functionId);
										}
									})
								}
							})
						}
					});
				}
				
				// api
				const that = this;
				let url = `/sys/role/function/acl/save`;
				
				const updateData = {
					roleId: this.acl.role.roleId,
					functionIds: this.checkedFunctionIds,
				}
				
				this.axios.post(url, updateData).catch(() => {
					that.acl.submiting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
					
							that.acl.dialog = false;
							that.acl.submiting = false;
							return;
						} else {
							that.acl.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.acl.submiting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			btnCheckboxChanged(item){
				// 处理页面的自动选择
				this.functionList.forEach((item,index)=>{
					item.children.forEach((page,m)=>{					
						let hasPage = "0";
						page.children.forEach((btn,n)=>{
							
							if (btn.hasAcl =="1"){
								hasPage = "1";
							}
						})
						page.hasAcl = hasPage;
					})
					
				})
			},
			getRoleAclList(){
				// 获取角色权限列表
				const that = this;		
				let url = `/sys/role/function/acl/list/`+this.acl.role.roleId;
				this.axios.get(url).then(response => {
					if (response.data["code"] === 200) {
						that.functionList = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
